// api/styleCategoryApi.js
import { apiRequest } from '@/api'

export const styleCategoryApi = {
  getList() {
    return apiRequest('/api/style-categories')
  },

  create(data) {
    return apiRequest('/api/style-categories', {
      method: 'POST',
      body: data
    })
  },

  update(data) {
    return apiRequest('/api/style-categories', {
      method: 'PUT',
      body: data
    })
  },

  delete(id) {
    return apiRequest('/api/style-categories', {
      method: 'DELETE',
      body: { id }
    })
  }
}